import { Injector } from "@angular/core";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../../Art57Node/Art57Node";
import { Art57NodeList } from "../../Art57Node/Art57NodeList";
import { BaseNode } from "../../BaseNode";
import { TreeNodeOldDrugIngredientEntity } from "../Entity/TreeNodeOldDrugIngredientEntity";
import { environment } from "../../../../../../environments/environment";


export class TreeNodeMedicinalProductsOldDrugIngredientsList extends Art57NodeList {
    constructor(injector: Injector, parent: BaseNode) {
      super(injector, new ListView(), 'Old Drug Ingredients ({param})');
      this.parent = parent;
      this.labelNodeName = 'Old Drug Ingredients';
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
      if (this.parent) {
        (this.parent as Art57Node).refreshLabel();
      }
    }
  
    override createChildTemplate(params: any): Art57Node[] | null {
      let node = new TreeNodeOldDrugIngredientEntity(this.ioc!, this);
      this.children?.push(node);
  
      this.refreshLabel();
      return [node];
    }
        
    override getHeaders(): string[] {
      return ['Substance Name', 'Role of Ingredient', 'Type Concentration',  
              'Concentration Unit Code', 'Concentration', 'Concentration 2 (range)'
             ];
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: TreeNodeMedicinalProductsOldDrugIngredientsList = new TreeNodeMedicinalProductsOldDrugIngredientsList(this.ioc!,newParent);      

      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));

      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)
  
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
// property doesn't exist      clonedNode.cloningNode = false;
      return clonedNode;
    }

  }